import { render, staticRenderFns } from "./FuelConsumption.vue?vue&type=template&id=2faa8591&scoped=true&"
import script from "./FuelConsumption.vue?vue&type=script&lang=js&"
export * from "./FuelConsumption.vue?vue&type=script&lang=js&"
import style0 from "./FuelConsumption.vue?vue&type=style&index=0&id=2faa8591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa8591",
  null
  
)

export default component.exports